<template>
  <div class="customer">
    <div class="request_tracking">
      <div class="title">
        <h3>
          {{ $lange == "en" ? "Request Quantity Tracking" : "请求数量跟踪" }}
        </h3>
      </div>
      <div class="content">
        <div class="search">
          <el-date-picker
            v-model="reqYear"
            type="year"
            size="mini"
            value-format="yyyy"
            style="width: 120px"
            @input="searchTracking"
          >
          </el-date-picker>
        </div>
        <div class="graph">
          <MonthRowTable :data="rowData" class="graph_table" />
          <GraphRequestTracking :data="rowData" />
        </div>
      </div>
    </div>
    <div class="request_tracking">
      <div class="title">
        <h3>
          {{
            $lange == "en"
              ? "Request Quantity Tracking By status"
              : "请求数量跟踪-按状态"
          }}
        </h3>
      </div>
      <div class="content">
        <div class="search">
          <el-date-picker
            v-model="reqMonth"
            type="month"
            size="mini"
            style="width: 120px"
            value-format="yyyy-MM"
            @input="searchTrackingMonth"
          >
          </el-date-picker>
        </div>
        <!-- 状态 -->
        <div>
          <div class="graph graph_flex">
            <div class="graph_table_tiny" style="width: 200px">
              <el-table
                size="mini"
                header-cell-class-name="table-cell-style"
                :data="statusData"
                border
              >
                <el-table-column
                  prop="code"
                  :label="$lange == 'en' ? 'Status' : '状态'"
                >
                  <template slot-scope="slot">
                    <span>{{ constants[slot.row.code] }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="value"
                  :label="$lange == 'en' ? 'Requests' : '当月请求'"
                ></el-table-column>
              </el-table>
            </div>
            <div class="graph_chart" style="width: calc(100% - 200px)">
              <RequestStatusPie class="graph_pie" :data="statusData" />
              <RequestStatusBar
                class="graph_bar status-bar"
                :data="statusData"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="request_tracking">
      <div class="title">
        <h3>
          {{
            $lange == "en"
              ? "Request Quantity Tracking By responsible"
              : "请求数量跟踪-按处理人"
          }}
        </h3>
      </div>
      <div class="content">
        <div class="graph graph_flex">
          <div class="graph_table_tiny" style="width: 400px">
            <el-table
              height="402"
              size="mini"
              header-cell-class-name="table-cell-style"
              :data="employeeData"
              border
            >
              <el-table-column
                prop="code"
                :label="$lange == 'en' ? 'Responsible' : '处理人'"
                min-width="100px"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="counter"
                :label="$lange == 'en' ? 'Total Requests' : '总请求'"
              ></el-table-column>
              <el-table-column
                prop="value"
                :label="$lange == 'en' ? 'Processing' : '处理中'"
              ></el-table-column>
            </el-table>
          </div>
          <div style="width: calc(100% - 400px)">
            <RequestEmpPie
              class="graph_pie-other"
              style="margin-left: 8px"
              :data="employeeData"
            />
          </div>
        </div>
        <div>
          <RequestEmpBar class="graph_bar-other" :data="employeeData" />
        </div>
      </div>
    </div>
    <div class="request_tracking">
      <div class="title">
        <h3>{{ $lange == "en" ? "Failure mode Tracking" : "故障分类跟踪" }}</h3>
      </div>
      <div class="content">
        <div class="search">
          <el-date-picker
            v-model="reqDate"
            type="daterange"
            size="mini"
            value-format="yyyy-MM-dd"
            @input="queryCategoryProblem"
          >
          </el-date-picker>
        </div>
        <div>
          <div class="graph graph_flex graph_media_query">
            <div class="graph_table_tiny">
              <el-table
                size="mini"
                header-cell-class-name="table-cell-style"
                :data="malProblemData"
                border
              >
                <el-table-column
                  prop="name"
                  :label="$lange == 'en' ? 'Failure mode' : '故障分类'"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="count"
                  :label="$lange == 'en' ? 'Quantity' : '数量'"
                ></el-table-column>
              </el-table>
            </div>
            <div class="graph_chart chart_media_query">
              <RequestProblemBar
                class="graph_bar"
                :title="
                  $lange == 'en' ? 'Failure mode Tracking' : '故障分类跟踪'
                "
                :data="malProblemData"
              />
              <RequestProblemPie
                class="graph_pie"
                :title="
                  $lange == 'en' ? 'Failure mode Tracking' : '故障分类跟踪'
                "
                :data="malProblemData"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="request_tracking">
      <div class="title">
        <h3>
          {{ $lange == "en" ? "Failure source Tracking" : "故障来源跟踪" }}
        </h3>
      </div>
      <div class="content">
        <div class="search">
          <el-date-picker
            v-model="reqDate2"
            type="daterange"
            size="mini"
            value-format="yyyy-MM-dd"
            @input="querySourceProblem"
          >
          </el-date-picker>
        </div>
        <div>
          <div class="graph graph_flex graph_media_query">
            <div class="graph_table_tiny">
              <el-table
                size="mini"
                :data="problemData"
                header-cell-class-name="table-cell-style"
                border
              >
                <el-table-column
                  prop="name"
                  :label="$lange == 'en' ? 'Failure source' : '故障来源'"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="count"
                  :label="$lange == 'en' ? 'Quantity' : '数量'"
                ></el-table-column>
              </el-table>
            </div>
            <div class="graph_chart chart_media_query">
              <RequestProblemBar
                class="graph_bar"
                :title="
                  $lange == 'en' ? 'Failure source Tracking' : '故障来源跟踪'
                "
                :data="problemData"
              />
              <RequestProblemPie
                class="graph_pie"
                :title="
                  $lange == 'en' ? 'Failure source Tracking' : '故障来源跟踪'
                "
                :data="problemData"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 客户请求统计表
import moment from "moment";

import MonthRowTable from "./components/MonthRowTable.vue";
import GraphRequestTracking from "./graph/RequestTracking.vue";
import RequestStatusPie from "./graph/RequestStatusPie.vue";
import RequestStatusBar from "./graph/RequestStatusBar.vue";
import RequestEmpPie from "./graph/RequestEmpPie.vue";
import RequestEmpBar from "./graph/RequestEmpBar.vue";
import RequestProblemBar from "./graph/RequestProblemBar.vue";
import RequestProblemPie from "./graph/RequestProblemPie.vue";

// const tableHeaderMap = {
//   countProcessed: "处理中",
//   countFinish: "已完成",
//   countObservation: "观察中",
//   countClose: "已关闭",
//   countCreate: "总请求",
// };

export default {
  name: "Customer",
  components: {
    GraphRequestTracking,
    MonthRowTable,
    RequestStatusPie,
    RequestStatusBar,
    RequestEmpPie,
    RequestEmpBar,
    RequestProblemBar,
    RequestProblemPie,
  },
  data() {
    const firstDate = moment().startOf("month").format("YYYY-MM-DD");
    const endDate = moment().endOf("month").format("YYYY-MM-DD");
    const toYear = moment().format("YYYY");
    return {
      /**
       * {
       *  "month-header": "asd",
       *  "month-1": "iii",
       *  "month-2": "ajd",
       * },
       */
      rowData: [],
      reqYear: toYear,

      //
      reqMonth: "2021-11",
      statusData: [],
      employeeData: [],
      constants: {
        processed: this.$lange == "en" ? "Processing" : "处理中",
        observation: this.$lange == "en" ? "Monitoring" : "观察中",
        finish: this.$lange == "en" ? "Completed" : "已完成",
        close: this.$lange == "en" ? "Closed" : "已关闭",
        cancel: this.$lange == "en" ? "Cancel" : "已取消",
      },
      tableHeaderMap: {
        countProcessed: this.$lange == "en" ? "Processing" : "处理中",
        countFinish: this.$lange == "en" ? "Completed" : "已完成",
        countObservation: this.$lange == "en" ? "Monitoring" : "观察中",
        countClose: this.$lange == "en" ? "Closed" : "已关闭",
        countCreate: this.$lange == "en" ? "Total Requests" : "总请求",
      },

      //
      reqDate: [firstDate, endDate],
      reqDate2: [firstDate, endDate],
      // 故障分类
      malProblemData: [],
      // 故障来源
      problemData: [],
    };
  },
  mounted() {
    this.fetchWordOrder({ year: this.reqYear }).catch((err) =>
      this.$message.error(err.response.data.message)
    );
    this.fetchStatusStat({ countTime: this.reqMonth }).catch((err) => {
      this.$message.error(err.response.data.message);
    });
    this.queryCategoryProblem(this.reqDate);
    this.querySourceProblem(this.reqDate);
  },
  methods: {
    searchTrackingCate(dateRange) {
      this.queryCategoryProblem(dateRange);
      this.querySourceProblem(dateRange);
    },
    searchTracking(val) {
      this.fetchWordOrder({ year: val }).catch((err) =>
        this.$message.error(err.response.data.message)
      );
    },
    searchTrackingMonth(month) {
      this.fetchStatusStat({ countTime: month }).catch((err) => {
        this.$message.error(err.response.data.message);
      });
    },
    filterTable(data) {
      let monthMap = Object.keys(this.tableHeaderMap).reduce((pre, cur) => {
        pre[cur] = {};
        return pre;
      }, {});
      data.forEach((item) => {
        for (const key in monthMap) {
          /**
           * 生成 monthMap:
           * {
           *  "countCreate": { 'month-1': 0, 'month-2': 12, ...},
           *  "countFinish": { 'month-1': 10, 'month-2': 12, ...},
           * ...
           * }
           */
          monthMap[key][`month-${item.month}`] = item[key];
        }
      });
      // 补上 month-header
      return Object.keys(this.tableHeaderMap).map((item) => ({
        "month-header": this.tableHeaderMap[item],
        ...monthMap[item],
      }));
    },
    queryCategoryProblem(date) {
      const [startTime, endTime] = date;
      this.fetchProblemData({ startTime, endTime, code: "malfunction" })
        .then((res) => {
          this.malProblemData = res;
        })
        .catch((err) => {
          this.$message.error(err.response.data);
        });
    },
    querySourceProblem(date) {
      const [startTime, endTime] = date;
      this.fetchProblemData({ startTime, endTime, code: "problem" })
        .then((res) => {
          this.problemData = res;
        })
        .catch((err) => {
          this.$message.error(err.response.data);
        });
    },
    async fetchWordOrder(payload) {
      const res = await this.ccRequest.do(
        "admin/fsb/customer/report/workOderStatistics",
        payload,
        "GET"
      );

      this.rowData = this.filterTable(res);
    },
    async fetchStatusStat(payload) {
      const res = await this.ccRequest.do(
        "admin/fsb/customer/report/workOderStatusStatistics",
        payload,
        "GET"
      );
      const { employeeList, statusList } = res;
      this.employeeData = employeeList;
      this.statusData = statusList;
    },
    async fetchProblemData(payload) {
      return await this.ccRequest.do(
        "admin/fsb/customer/report/countProblem",
        payload,
        "GET"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.customer {
  background: #f3f3f4;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
}
.request_tracking {
  /* border: 1px solid rgb(107, 105, 105); */
  /* border: 1px solid #6b6969; */

  box-sizing: border-box;
  margin-bottom: 8px;
  background-color: #fff;
}

.title {
  border-bottom: 1px solid #e4e4e4;

  padding: 10px 20px;
}

.content {
  padding: 10px;
}
.graph {
  margin-top: 16px;
}

.graph_table {
  margin: 16px 0;
}

.graph_flex {
  display: flex;
}

.graph_table_tiny {
  width: 400px;
}
.graph_pie {
  width: 400px;
  border: 1px solid #aaa7a788;
  margin-right: 8px;
}
.graph_chart {
  display: flex;
  width: calc(100% - 408px);
  margin-left: 8px;
}
.graph_bar {
  width: calc(100% - 400px);
  border: 1px solid #aaa7a788;
  margin-right: 8px;
}

.graph_pie-other {
  width: calc(100% - 8px);
  margin: 0 8px;
  border: 1px solid #aaa7a788;
}

@media screen and (max-width: 1280px) {
  .graph_pie-other {
    width: 100%;
  }

  .graph_media_query {
    display: block;
  }

  .chart_media_query {
    margin-left: 0;
    margin-top: 16px;
    width: 100%;
  }
  .chart_media_query .graph_bar {
    width: 50%;
  }
  .chart_media_query .graph_pie {
    width: 50%;
  }
}
.graph_bar-other {
  width: 100%;
  margin-top: 16px;
  border: 1px solid #aaa7a788;
}

.el-table {
  border: 1px solid #aaa7a788;
  font-size: 14px;
}

.el-table ::v-deep th.el-table__cell.is-leaf,
.el-table ::v-deep td.el-table__cell {
  border-bottom: 1px solid #aaa7a788;
  border-right: 1px solid #aaa7a788;
}

.status-bar {
  max-width: 600px;
}
</style>

<style>
.table-cell-style .cell {
  word-break: break-word;
}
</style>
